/* eslint-disable no-nested-ternary */
export const calcRangePadding = (dataMin = 0, dataMax = 0) => {
  const percent = dataMax < 50 ? 1 : dataMax < 100 ? 5 : 20

  const min = dataMin < 10 ? 0 : dataMin - (dataMax / 100) * percent
  const max = dataMax < 10 ? dataMax + 2 : dataMax + (dataMax / 100) * percent

  return [min, max]
}
